// A payer's own name, else its first other name (the server lists them oldest first).
export const payerDisplayName = (
  payer?: { name?: string | null; names?: Array<{ name?: string | null }> | null } | null,
): string | undefined => payer?.name?.trim() || payer?.names?.find((name) => name.name?.trim())?.name?.trim()
